/**
 * Editor core types and constants.
 *
 * Doc model (normalized flat tree):
 *   {
 *     root: string[],            // ordered top-level block ids
 *     blocks: Record<id, Block>  // all blocks keyed by id
 *   }
 *
 * Block:
 *   {
 *     id:       string,
 *     type:     string,          // matches a registry key
 *     attrs:    object,          // serializable block-specific data
 *     children: string[]|undefined  // ordered child block ids (containers only)
 *   }
 */

/** Empty document – a root container with no children. */
export const EMPTY_DOC = { root: [], blocks: {} };

/** Sentinel used in drag state when no drop target is active. */
export const NO_DROP = null;

/**
 * Build a new block object.
 * @param {string} type
 * @param {object} attrs
 * @param {string[]} [children]
 * @returns {{ id: string, type: string, attrs: object, children?: string[] }}
 */
export function makeBlock(type, attrs = {}, children) {
  const block = {
    id: `block-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    type,
    attrs,
  };
  if (children !== undefined) block.children = children;
  return block;
}
